import './video_swiper.scss';
import { global_hooks } from 'src/globals';

global_hooks.on('after_init', init);

function init() {
	document.querySelectorAll('.video_swiper').forEach((widget) => {
		const swiper_el = widget.querySelector('.swiper');
		if (!swiper_el) return;

		// Arrows live in a sibling HTML widget within the same container
		const scope =
			widget.closest('.e-con-inner') ||
			widget.closest('.e-con') ||
			widget.parentElement;

		const prev = scope?.querySelector('.video_swiper_arrow_prev');
		const next = scope?.querySelector('.video_swiper_arrow_next');
		if (!prev && !next) return;

		// Resolve the Swiper instance at click time (Elementor inits it lazily)
		prev?.addEventListener('click', () => swiper_el.swiper?.slidePrev());
		next?.addEventListener('click', () => swiper_el.swiper?.slideNext());
	});
}
